module.exports = __webpack_public_path__ + "static/media/intro_icon_4.bfb339d4.svg";